import React from 'react'
import { Gem, Bomb } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const MinesBoard = ({ game, result, onClick, locked = true }) => {
  const { t } = useTranslation()
  const opened = game?.opened || result?.opened || []
  const mines = result?.mines_cells || []
  const boom = result?.boom_cell

  return (
    <div role="group" aria-label={t('mines.board')} className="grid grid-cols-5 gap-1.5 sm:gap-2">
      {Array.from({ length: 25 }, (_, cell) => {
        const step = opened.indexOf(cell)
        const isMine = mines.includes(cell)
        const isBoom = boom === cell
        const label = isBoom ? t('mines.exploded') : isMine ? t('mines.mine') : step >= 0 ? t('mines.safeStep', { step: step + 1 }) : result ? t('mines.safe') : t('mines.openCell')
        return (
          <button key={cell} type="button" disabled={locked || step >= 0 || Boolean(result)} onClick={() => onClick(cell)}
            aria-label={`${t('mines.cell', { cell: cell + 1 })}: ${label}`}
            className={`aspect-square min-w-0 rounded-xl border-2 flex items-center justify-center transition-transform duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent-primary enabled:active:scale-95 ${isBoom ? 'border-red-400 bg-red-950 text-red-400' : isMine ? 'border-red-500/40 bg-red-950/30 text-red-400' : step >= 0 ? 'border-accent-primary/70 bg-emerald-950 text-accent-primary' : result ? 'border-white/10 bg-surface/60 text-text-secondary' : 'border-emerald-700/50 bg-gradient-to-br from-emerald-950 to-surface shadow-[inset_0_1px_8px_rgba(0,255,127,0.14)] enabled:hover:border-accent-primary'}`}>
            {isMine ? <Bomb className="h-6 w-6 sm:h-9 sm:w-9" /> : step >= 0 ? <Gem className="h-6 w-6 sm:h-9 sm:w-9" /> : null}
          </button>
        )
      })}
    </div>
  )
}

export default MinesBoard
